export default "__VITE_ASSET__ByeZXr83__"